import type { ReactNode } from "react";

import { Tooltip } from "@alpacahq/ui/old";

import { cn } from "~/v2/utils/cn";

interface ProgramColumnProps {
  icon: ReactNode;
  label: string;
  value: string;
  isLoading: boolean;
  prefix?: string;
}

export const ProgramColumn = ({
  icon,
  label,
  value,
  isLoading,
  prefix,
}: ProgramColumnProps) => (
  <div className="flex flex-col items-start gap-y-0">
    <div className="mt-2 flex flex-row items-start gap-x-2">
      {icon}
      <Tooltip content="Estimated interest is updated daily after markets close.">
        <span className="m-1 cursor-help whitespace-nowrap border-gray-400 border-b-2 border-dotted font-medium text-gray-700 text-sm">
          {label}
        </span>
      </Tooltip>
    </div>
    <div className="flex items-center gap-x-2">
      {isLoading ? (
        <div className="mt-0.5 h-4 w-16 animate-pulse rounded bg-gray-200" />
      ) : (
        <span
          className={cn(
            "mt-0.5 whitespace-nowrap font-medium font-mono text-sm",
            value !== "$0" ? "text-gray-700" : "text-gray-400",
          )}
        >
          {value !== "$0" && prefix}
          {value}
        </span>
      )}
    </div>
  </div>
);
